import { PHONE_NUMBER_MASK } from '@exam-center/utils';
import IMask from 'imask';
import { z } from 'zod';

export const BlockedUserSchema = z.object({
  phoneNumber: z
    .string()
    .optional()
    .refine(
      (val) => {
        if (!val) return true;
        const mask = IMask.createMask({ mask: PHONE_NUMBER_MASK });
        mask.resolve(val);
        return mask.isComplete;
      },
      { message: 'รูปแบบเบอร์โทรศัพท์ไม่ถูกต้อง' },
    ),
});

export type BlockedUserFormInput = z.infer<typeof BlockedUserSchema>;
